
import {Component, Prop, Vue} from 'vue-property-decorator';
import FormGroup from "@/UI/components/common/form/FormGroup.vue";

import VisitGeneralForm from "@/form/visits/visitGeneral";

import VisitDetailModalForm from "@/UI/components/forms/visits/detail/VisitDetailModalForm.vue";

import moment from 'moment';



@Component({
    components: {FormGroup, VisitDetailModalForm},
    methods: {moment}
})
export default class VisitDetailFormComponent extends Vue {
    @Prop() form!:  VisitGeneralForm;

    async created(): Promise<void> {
        console.log('creted');
    }
}
